module.exports = __webpack_public_path__ + "img/otomi.529ff882.svg";